import { setFilter } from 'src/redux/slices/eLearning/list'

export const handleChangeSearch = (value) => (dispatch) => {
  const payload = { key: 'courseName', value }
  dispatch(setFilter(payload))
}
